import { render, staticRenderFns } from "./ParentMenuGroup.vue?vue&type=template&id=842ddba0"
import script from "./ParentMenuGroup.vue?vue&type=script&lang=js"
export * from "./ParentMenuGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports